/**
 * Created by vladislav on 18.07.2022
 */

const UnitLocator = {
    find: function (type, targetUnit, options) {
        options = options || {};

        const isMagicCrystal = targetUnit && targetUnit.code === "crystal" && targetUnit.stage === 3;

        const minUnits = options.minUnits || 3;

        const center = Map2d.currentMap.getScreenCenterCell();
        let units;

        if (options.monster) {
            units = cleverapps.toArray(this.getMonsters(options.monster));
        } else {
            units = cleverapps.toArray(this.getTargetUnits(type, targetUnit, options));
        }

        if (type === Map2d.MERGE && targetUnit && targetUnit.code === "wands" && units.length < minUnits) {
            type = Map2d.COMPLETE_ORDER;
            units = cleverapps.toArray(this.getTargetUnits(type, targetUnit, options));
        }

        const amounts = {};
        let maxAmount = 0;
        let maxAmountKey = 0;
        units.forEach((unit) => {
            if (unit instanceof Unit && unit.isMergeable(unit)) {
                const key = Unit.GetKey(unit);
                amounts[key] = (amounts[key] || 0) + 1;

                if (amounts[key] > maxAmount) {
                    maxAmount = amounts[key];
                    maxAmountKey = key;
                }
            }
        });
        units = units.filter((unit) => {
            if (options.resource) {
                return true;
            }
            if (type === Map2d.MERGE) {
                return isMagicCrystal && unit.isMagicCrystal()
                    || Unit.GetKey(unit) === maxAmountKey && amounts[Unit.GetKey(unit)] >= minUnits && unit.isMergeable(unit);
            }
            return !amounts[Unit.GetKey(unit)] || unit.getData().chest || amounts[Unit.GetKey(unit)] >= minUnits;
        }, this);

        units.sort((a, b) => {
            const stageA = this.getWeight(type, targetUnit, a);
            const stageB = this.getWeight(type, targetUnit, b);
            if (stageA !== stageB) {
                return stageA - stageB;
            }
            return cc.getDistanceChebyshev(a, center) - cc.getDistanceChebyshev(b, center);
        });

        if (options.searchSources && !units.length) {
            let currentUnit;
            units = Map2d.currentMap.listAvailableUnits((unit) => {
                if (unit.getType() === "chest" || unit.getType() === "source" && unit.findComponent(Mineable)) {
                    return !currentUnit || cc.getDistanceChebyshev(currentUnit, center) - cc.getDistanceChebyshev(unit, center) > 0;
                }
            });
        }

        if (options.searchFakeSources && options.getFindTargets && !units.length) {
            const searchTargets = options.getFindTargets();
            units = Map2d.currentMap.fogs.listFakeUnits((fakeUnit) => {
                const fogTile = Map2d.currentMap.getFog(fakeUnit.x, fakeUnit.y);
                return fogTile && fogTile.fromBlockedGround() && searchTargets.includes(fakeUnit.code);
            });
        }

        if (cleverapps.meta.getSelectedLocation().locationConfig.usePathIndicator) {
            if (units.length > 0 && Map2d.currentMap.pathIndicator.indicate(units[0], {
                silent: options.silent,
                alwaysShowIndicator: options.alwaysShowIndicator
            })) {
                return true;
            }

            if (options.silent) {
                return false;
            }
        }

        if (units.length === 0) {
            cleverapps.notification.create(Messages.get("Quest.find.empty"));
            return false;
        }

        let adviceMove;

        if (type === Map2d.MERGE && Map2d.currentMap.advice) {
            Map2d.currentMap.advice.setLogic(Map2d.MERGE, {
                targets: units,
                minUnits,
                highlight: true
            });
            Map2d.currentMap.advice.startHintOnce();
        } else if (options.tryAdvice && Map2d.currentMap.advice
            && !units.some((unit) => unit.code === targetUnit.code && unit.stage === targetUnit.stage)) {
            const familyTargets = units.filter((unit) => unit.code === targetUnit.code && unit.stage < targetUnit.stage);
            if (familyTargets.length > 0) {
                Map2d.currentMap.advice.setLogic(Map2d.MERGE, {
                    targets: familyTargets,
                    minUnits,
                    highlight: true
                });
                adviceMove = Map2d.currentMap.advice.findMove();
                if (adviceMove) {
                    Map2d.currentMap.advice.startHintOnce();
                }
            }
        }

        const focusTarget = (adviceMove && adviceMove.arrow) || units[0];

        Map2d.currentMap.focusOnUnit(focusTarget, {
            allowScrollWithFocus: options.allowScrollWithFocus,
            skipFocusReport: true,
            callback: adviceMove ? undefined : function () {
                FingerView.hintTap({ x: units[0].x, y: units[0].y }, { runOnce: true });
            }
        });

        return true;
    },

    getWeight: function (type, targetUnit, unit) {
        const targetCode = targetUnit && targetUnit.code;
        const targetStage = targetUnit && targetUnit.stage;
        const targetType = targetUnit && targetUnit.type;

        const typePriority = ["unitsshop", "chest", "source", "generator"].map(cleverapps.unitsLibrary.getExpeditionUnitType);

        let res = 0;
        let stageSign = -1;

        if (type === Map2d.BUILD && targetStage === undefined && Unit.IsApplicable(unit, unit)) {
            const buildable = unit.findComponent && unit.findComponent(Buildable);
            if (buildable && !buildable.isCompleted()) {
                stageSign = 1;
                res -= 20;
            }
        }

        const resourceName = function (code) {
            return code.replace(/(chest|source|generator)$/, "");
        };

        res += stageSign * unit.stage;
        if (targetCode && targetCode === unit.code) {
            res -= 3000;
        } else if (targetCode && unit.code && resourceName(targetCode) === resourceName(unit.code)) {
            res -= 2000;
        } else if (targetType && unit.getType && targetType === unit.getType()) {
            res -= 1000;
        }
        res += (typePriority.indexOf(unit.getType()) + 1) * 100;
        return res;
    },

    getMonsters: function (monster) {
        const monsters = [];
        const region = Map2d.currentMap.regions.monsters;
        for (let i = 0; i < region.positions.length; i++) {
            const unit = Map2d.currentMap.getUnit(region.positions[i].x, region.positions[i].y);
            if (unit && unit.getData().monster === monster) {
                monsters.push(unit);
            }
        }
        return monsters;
    },

    getTargetUnits: function (type, unit, options) {
        const getFindTargets = options.getFindTargets;
        const map = Map2d.currentMap;

        switch (type) {
            case Map2d.SPAWN:
            case Map2d.OPENCHEST: {
                const chests = map.listAvailableUnits(unit);
                if (chests.length > 0 && !options.skipUnitStage && !options.useStageForCustomerSearch && !getFindTargets) {
                    return chests;
                }

                if (options.exactStage && unit.stage !== undefined && !getFindTargets) {
                    return this.getExactStageTargets(unit, map);
                }

                let units;
                let customer;
                if (options.useStageForCustomerSearch) {
                    units = map.fogs.listFakeUnits((fogUnit) => map.getFog(fogUnit.x, fogUnit.y) && Unit.IsApplicable(unit, fogUnit));
                    if (units.length === 0) {
                        units = map.listAvailableUnits(unit);
                    }
                    customer = Map2d.currentMap.customers.findCustomerForHint(unit);
                    if (customer) {
                        units = [customer];
                    }
                } else {
                    if (options.includePrizeView) {
                        Map2d.currentMap.listAvailableUnits().forEach((mapUnit) => {
                            if (Array.isArray(mapUnit.prizes) && mapUnit.prizes.find((prize) => (Unit.Equals(unit, prize)))) {
                                units = units ? units.concat(mapUnit) : [mapUnit];
                            }
                        });
                    }

                    if (!units || units.length === 0) {
                        units = map.listAvailableUnits(this.getSpawnTargets(unit, 0, getFindTargets, options.skipUnitStage));
                        customer = Map2d.currentMap.customers.findCustomerForHint(unit);
                        if (customer) {
                            units = units.concat([customer]);
                        }
                        if (units.length === 0) {
                            units = map.fogs.listFakeUnits(this.getSpawnTargets(unit, 1, getFindTargets)).filter((unit) => map.getFog(unit.x, unit.y));
                        }
                    }
                }

                units.sort((unit1, unit2) => {
                    const fog1 = map.getFog(unit1.x, unit1.y);
                    const fog2 = map.getFog(unit2.x, unit2.y);

                    return Boolean(fog1) - Boolean(fog2) || Boolean(fog2 && fog2.fromBlockedGround()) - Boolean(fog1 && fog1.fromBlockedGround());
                });

                return units;
            }

            case Map2d.HARVEST:
            case Map2d.FEED_HERO:
            case Map2d.PRIZE_HARVESTED:
                return map.listAvailableUnits(this.getSpawnTargets(unit, 1, getFindTargets));

            case Map2d.MINE:
            case Map2d.COMPLETE_MINING:
            case Map2d.BUY_FREE_UNIT: {
                const mineUnits = map.listAvailableUnits(unit).filter((u) => {
                    const mineable = u.findComponent(Mineable);
                    return !mineable || !mineable.isCompleted();
                });
                if (mineUnits.length) {
                    return mineUnits;
                }

                const mineFakeUnits = map.fogs.listFakeUnits(unit).filter((fakeUnit) => fakeUnit.pointOfInterest);
                if (mineFakeUnits.length) {
                    return mineFakeUnits;
                }

                const allFakeUnits = map.fogs.listFakeUnits(unit).filter((u) => map.getFog(u.x, u.y));
                if (allFakeUnits.length) {
                    return allFakeUnits;
                }

                return [];
            }

            case Map2d.BUILD:
                return this.getBuildUnits(unit, getFindTargets);

            case Map2d.OPENFOG: {
                let fog;
                if (options.target) {
                    fog = map.fogs.getBlockById(options.target);
                } else {
                    fog = map.fogs.findAvailableFogBlock();
                }

                return fog && fog.head || [];
            }

            case Map2d.OPENDRAGON:
                return map.fogs.blocks.dragonIsland.head;

            case Map2d.MERGE: {
                const isMagicCrystal = unit && unit.code === "crystal" && unit.stage === 3;
                if (isMagicCrystal) {
                    return map.listAvailableUnits();
                }
                if (options.skipUnitStage) {
                    return map.listAvailableUnits(
                        (candidate) => candidate.code === unit.code && candidate.stage < Families[unit.code].units.length - 1
                    );
                }
                return map.listAvailableUnits(unit);
            }

            case Map2d.COMPLETE_ORDER: {
                const ready = Map2d.currentMap.customers.findReady();

                if (ready) {
                    return ready.unit;
                }

                const customersWithRecipe = Map2d.currentMap.customers.listCustomersWithRecipe();
                if (customersWithRecipe.length > 0) {
                    return customersWithRecipe.map((customer) => customer.unit);
                }

                return Map2d.currentMap.customers.listCustomers().map((customer) => customer.unit);
            }

            case Map2d.USE_UP_INSTANT_WORKER: {
                const free = Map2d.currentMap.workers.listInstantFree();
                if (free.length > 0) {
                    return free.map((worker) => worker.unit);
                }

                return Map2d.currentMap.workers.listInstant().map((unit) => unit.assignment.unit);
            }

            case Map2d.OPEN_UNIT: {
                const openFakeUnit = map.fogs.findFakeUnit(unit);
                if (openFakeUnit && openFakeUnit.pointOfInterest) {
                    return openFakeUnit;
                }

                return map.listAvailableUnits(this.getSpawnTargets(unit, 0, getFindTargets));
            }

            case Map2d.RECIPE_READY:
                return map.listAvailableUnits(unit);
        }
        return [];
    },

    getBuildUnits: function (unit, getFindTargets) {
        const targets = unit && unit.code ? this.getSpawnTargets(unit, 1, getFindTargets) : {};

        let units = Map2d.currentMap.listAvailableUnits(targets).filter((unit) => {
            const buildable = unit.findComponent(Buildable);
            return !buildable || !buildable.isCompleted();
        }, this);

        const customer = Map2d.currentMap.customers.findCustomerForHint(unit);
        if (customer) {
            units = units.concat([customer]);
        }

        return units;
    },

    getSpawnTargets: function (unit, stageDelta, getFindTargets, skipUnitStage) {
        stageDelta = stageDelta || 0;

        let targets = [];

        if (getFindTargets) {
            getFindTargets(unit).forEach((code) => {
                targets = targets.concat(Unit.getAllStagesTargets(code));
                if (skipUnitStage) {
                    targets = targets.filter((candidate) => candidate.code !== unit.code || (candidate.code === unit.code && candidate.stage !== unit.stage));
                }
            });
            return targets;
        }

        if (unit.stage !== undefined) {
            targets = Unit.getPreviousStagesTargets(unit.code, unit.stage + stageDelta);
        } else if (unit.code !== undefined) {
            targets = Unit.getAllStagesTargets(unit.code);
        }

        cleverapps.unitsLibrary.listCodesByType(["chest", "source", "generator", "rpchest", "seasource", "seachest", "unitsshop"])
            .forEach((source) => {
                targets = targets.concat(Unit.getAllStagesTargets(source));
            });

        if (Families[unit.code].type === "rpresource") {
            targets = targets.concat(Unit.getAllStagesTargets(`${unit.code}source`));
        }

        return targets;
    },

    getExactStageTargets: function (unit, map) {
        const listByTypes = (types) => {
            let targets = [];
            cleverapps.unitsLibrary.listCodesByType(types).forEach((code) => {
                targets = targets.concat(Unit.getAllStagesTargets(code));
            });
            return map.listAvailableUnits(targets);
        };

        const previousStages = map.listAvailableUnits(Unit.getPreviousStagesTargets(unit.code, unit.stage));
        if (previousStages.length) {
            previousStages.sort((unit1, unit2) => unit2.stage - unit1.stage);
            return previousStages;
        }

        const sourcesChests = listByTypes(["chest", "source", "rpchest", "seasource", "seachest", "unitsshop"]);
        if (sourcesChests.length) {
            return sourcesChests;
        }

        return listByTypes(["generator"]);
    },

    findPrize: function (lost) {
        const units = [];
        let spawner;

        Map2d.currentMap.listAvailableUnits((unit) => {
            if (unit.prizes && this.findInPrizes(unit.prizes, lost)) {
                units.push(unit);
                return;
            }

            if (this.findInMineablePrizes(unit, lost)) {
                units.push(unit);
            }

            if (typeof Spawner !== "undefined" && unit.findComponent(Spawner)) {
                spawner = unit;
            }
        });

        if (!units.length && spawner) {
            units.push(spawner);
        }

        if (!units.length) {
            Map2d.currentMap.fogs.listFakeUnits((unit) => {
                const fogTile = Map2d.currentMap.getFog(unit.x, unit.y);
                if (fogTile && fogTile.fogBlock && !fogTile.fogBlock.isMoney() && this.findInMineablePrizes(unit, lost)) {
                    units.push(unit);
                }
            });
        }

        if (!units.length) {
            cleverapps.notification.create(Messages.get("Quest.find.empty"));
            return;
        }

        const center = Map2d.currentMap.getScreenCenterCell();

        units.sort((a, b) => {
            const fog1 = Map2d.currentMap.getFog(a.x, a.y);
            const fog2 = Map2d.currentMap.getFog(b.x, b.y);
            const lockedA = Boolean(a.getData && a.getData().lockable);
            const lockedB = Boolean(b.getData && b.getData().lockable);

            return Boolean(fog1) - Boolean(fog2) || lockedA - lockedB || Boolean(fog2 && fog2.fromBlockedGround()) - Boolean(fog1 && fog1.fromBlockedGround()) || cc.pDistanceSQ(center, a) - cc.pDistanceSQ(center, b);
        });

        Map2d.currentMap.focusOnUnit(units[0], {
            allowScrollWithFocus: lost.allowScrollWithFocus,
            skipFocusReport: true,
            callback: function () {
                FingerView.hintTap({ x: units[0].x, y: units[0].y }, { runOnce: true });
            }
        });
    },

    findInPrizes: function (prizes, lost) {
        if (!prizes || !Array.isArray(prizes)) {
            return false;
        }

        return prizes.some((prize) => {
            if (prize.units) {
                return this.findInPrizes(prize.units, lost);
            }

            return lost.resource && lost.resource === prize.resource
                || lost.ingredient && lost.ingredient === prize.ingredient
                || (lost.type !== undefined || lost.code !== undefined || lost.stage !== undefined) && Unit.IsApplicable(lost, prize);
        });
    },

    findInMineablePrizes: function (unit, lost) {
        const type = Families[unit.code].type;
        const data = Families[unit.code].units[unit.stage];

        for (let mined = 0; mined < (data.mineable && data.mineable.tasks && data.mineable.tasks.length); ++mined) {
            const prizes = Prizes.Generate(cleverapps.toArray(Mines[type](mined, unit)), { listOnly: true });

            if (this.findInPrizes(prizes, lost)) {
                return true;
            }
        }

        return false;
    },

    getFoodSource: function (feedable) {
        const readySources = [];
        const sources = [];
        let shop;

        Map2d.currentMap.listAvailableUnits((unit) => {
            if (unit.code === feedable.food.code && unit.readyFoodSource && unit.findComponent(Fruit).timeToReady() === 0) {
                readySources.push(unit);
            }

            if (unit.code === feedable.food.code) {
                sources.push(unit);
            }

            if (unit.getType() === "unitsshop") {
                shop = unit;
            }
        });

        let foodSource;

        const position = cc.p(feedable.unit.x, feedable.unit.y);
        if (readySources.length > 0) {
            foodSource = readySources.sort((a, b) => cc.pDistanceSQ(position, a) - cc.pDistanceSQ(position, b))[0];
        } else if (sources.length > 0) {
            foodSource = sources.sort((a, b) => b.stage - a.stage || cc.pDistanceSQ(position, a) - cc.pDistanceSQ(position, b))[0];
        } else if (shop) {
            foodSource = shop;
        } else {
            foodSource = Map2d.currentMap.fogs.findFakeUnit([{ type: "unitsshop" }]);
        }

        return foodSource;
    }
};
